import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, withTheme } from 'styled-components';
import { GlobalStyles, lightTheme, Logo } from 'react-komponents';

const LogoWithTheme = withTheme(({ color, theme }) => (
  <Logo
    firstPart="Julien"
    secondPart="Karst."
    color={color}
    fontSize={theme.fontSize.large}
    fontFamily={theme.font.brand}
    onClick={() => null}
  />
));

const MainLogo = ({ fill = 'white' }) => {
  return (
    <>
      <GlobalStyles />
      <ThemeProvider theme={lightTheme}>
        <LogoWithTheme color={fill} />
      </ThemeProvider>
    </>
  );
};

MainLogo.propTypes = {
  fill: PropTypes.string.isRequired,
};

export default MainLogo;
